module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "synthConfig"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Modulation Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulation.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulation', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Harmonicity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Modulation Index")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "50"
    },
    domProps: {
      "value": _vm.config.modulationIndex
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationIndex')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationIndex
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationIndex')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Modulation Envelope")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187bd351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/fmsynth.vue
// module id = 267
// module chunks = 1